/**
 * App screens configuration for deep linking
 * Based on fit-mobile/src/Utils/linking.js and navigation structure
 */

export const APP_SCREENS = [
  // Ana Səhifələr (Main Tabs)
  {
    path: 'home',
    label: 'Ana Səhifə',
    category: 'Ana Səhifələr',
  },
  {
    path: 'weight',
    label: 'Çəki',
    category: 'Ana Səhifələr',
  },
  {
    path: 'notifications',
    label: 'Bildirişlər',
    category: 'Ana Səhifələr',
  },
  {
    path: 'account',
    label: 'Hesab',
    category: 'Ana Səhifələr',
  },

  // Abunəlik (Subscription)
  {
    path: 'paySubscription',
    label: 'Abunəlik Ödənişi',
    category: 'Abunəlik',
  },

  // Yardım (Help)
  {
    path: 'helpCenter/conversation',
    label: 'Yardım Mərkəzi',
    category: 'Yardım',
  },

  // Alış-Veriş (Shopping)
  {
    path: 'shoppingList',
    label: 'Alış-Veriş Siyahısı',
    category: 'Alış-Veriş',
  },

  // Su (Water)
  {
    path: 'water',
    label: 'Su Kontrolu',
    category: 'Su',
  },
  {
    path: 'water/create',
    label: 'Su Qeydi əlavə etmək',
    category: 'Su',
  },

  // Fəaliyyət (Activity)
  {
    path: 'walking/show',
    label: 'Gəzinti Fəaliyyəti',
    category: 'Fəaliyyət',
  },

  // Yemək (Meal)
  {
    path: 'meal/scan',
    label: 'Yemək Skana Et',
    category: 'Yemək',
  },
  {
    path: 'meal/create',
    label: 'Yemək Yarat',
    category: 'Yemək',
  },

  // Pəhriz Planı (Meal Plan)
  {
    path: 'meal-plan',
    label: 'Pəhriz Planı',
    category: 'Pəhriz Planı',
  },

  // Qidalanma (Nutrition)
  {
    path: 'meal-log',
    label: 'Qidalanma Gündəliyi',
    category: 'Qidalanma',
  },
];

/**
 * Get all screens grouped by category
 */
export const getScreensByCategory = () => {
  const grouped = {};
  APP_SCREENS.forEach(screen => {
    if (!grouped[screen.category]) {
      grouped[screen.category] = [];
    }
    grouped[screen.category].push(screen);
  });
  return grouped;
};

/**
 * Get screen label by path
 */
export const getScreenLabel = (path) => {
  const screen = APP_SCREENS.find(s => s.path === path);
  return screen ? screen.label : path;
};

/**
 * Get all screen paths
 */
export const getAllScreenPaths = () => {
  return APP_SCREENS.map(screen => screen.path);
};

/**
 * Get all screens as options for select dropdown
 */
export const getScreenOptions = () => {
  return APP_SCREENS.map(screen => ({
    value: screen.path,
    label: screen.label,
  }));
};

/**
 * Get grouped screens as options for select dropdown (with optgroups)
 */
export const getGroupedScreenOptions = () => {
  const grouped = getScreensByCategory();
  const options = [];
  
  Object.keys(grouped).forEach(category => {
    options.push({
      type: 'group',
      label: category,
      options: grouped[category].map(screen => ({
        value: screen.path,
        label: screen.label,
      })),
    });
  });
  
  return options;
};

